const stats = [
{ title: "Sent Mails", value: "2000", color: "#1F6E73" },
  { title: "Average Clicked", value: "80%", color: "#F68727" },
  { title: "Report Rate", value: "60%", color: "#FF3131" },
  { title: "Opened Mail", value: "60%", color: "#BF7300" },
  { title: "Submitted Rate", value: "60%", color: "#217B3A" },
];

const MailStatCard = () => {
  return (
    <div
      className="
        mt-4 mb-5
        rounded-xl
        shadow
        bg-white dark:bg-slate-800
        border border-transparent dark:border-slate-700
      "
    >
      <div
        className="
          grid
          grid-cols-1
          sm:grid-cols-2
          lg:grid-cols-5
          text-center
          py-6
          px-2
        "
      >
        {stats.map((stat, idx) => (
          <div
            key={idx}
            className={`
              flex flex-col items-center justify-center
              ${
                idx !== stats.length - 1
                  ? "lg:border-r border-slate-300/40 dark:border-slate-600/40"
                  : ""
              }
            `}
          >
            <div
              className="text-lg font-medium"
              style={{ color: stat.color }}
            >
              {stat.title}
            </div>

            <div
              className="text-[40px] font-semibold leading-none"
              style={{ color: stat.color }}
            >
              {stat.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MailStatCard;